import React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import {CoachInfoCard} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {styles} from './Loading.style';

// Define the types for the component props
interface LoadingProps {
  tt: (key: string, fallback: string) => string;
}

const Loading: React.FC<LoadingProps> = ({
  tt = (key: string, fallback: string) => fallback, // Default function if tt is not provided
}) => {
  return (
    <View style={styles.footer}>
      <View style={styles.footerGroup}>
        <Text
          testID={CoachInfoCard.volumeTitle}
          emphasis="medium"
          variant="subheading"
          style={styles.footerGroupTitle}>
          {tt('footer.volume.label', 'Volume')}
        </Text>
        <View style={styles.footerRow}>
          <Text variant="button">{tt('footer.pqv.label', 'PQV')}</Text>
          <LoadingBox style={styles.footerBoxPQV} />
        </View>
        <View style={styles.footerRow}>
          <Text variant="button">{tt('footer.fqv.label', 'FQV')}</Text>
          <LoadingBox style={styles.footerBoxFQV} />
        </View>
        <View style={styles.footerRow}>
          <Text variant="button">{tt('footer.gqv.label', 'GQV')}</Text>
          <LoadingBox style={styles.footerBoxGQV} />
        </View>
        <View style={styles.footerRow}>
          <Text variant="button">{tt('footer.gen0qv.label', 'GEN0 QV')}</Text>
          <LoadingBox style={styles.footerBoxGEN0QV} />
        </View>
      </View>
      <View style={styles.footerGroup}>
        <Text
          testID={CoachInfoCard.teamsTitle}
          emphasis="medium"
          variant="subheading"
          style={styles.footerGroupTitle}>
          {tt('footer.teams.label', 'Teams')}
        </Text>
        <View style={styles.footerRow}>
          <Text variant="button">{tt('footer.sc.label', 'SC')}</Text>
          <LoadingBox style={styles.footerBoxSC} />
        </View>
        <View style={styles.footerRow}>
          <Text variant="button">{tt('footer.ed.label', 'ED')}</Text>
          <LoadingBox style={styles.footerBoxED} />
        </View>
        <View style={styles.footerRow}>
          <Text variant="button">{tt('footer.fibc.label', 'FIBC')}</Text>
          <LoadingBox style={styles.footerBoxFIBC} />
        </View>
        <View style={styles.footerRow}>
          <Text variant="button">{tt('footer.fibl.label', 'FIBL')}</Text>
          <LoadingBox style={styles.footerBoxFIBL} />
        </View>
      </View>
    </View>
  );
};

export default withHOC(withTranslation('reportCard.coach'))(Loading);
